import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { Link } from "react-router-dom";

import RadialChart1 from "./userpanelChart1";
import RadialChart2 from "./userpanelChart2";
import RadialChart3 from "./userpanelChart3";

const UserPanel = ({ metrics }) => {
  return (
    <React.Fragment>
      <Row>
        {/* Total Users */}
        <Col xl={3} sm={6}>
          <Card>
            <CardBody>
              <Link to="/users" className="text-muted">
                <div className="d-flex text-muted">
                  <div className="flex-shrink-0 me-3 align-self-center">
                    <i className="mdi mdi-account-group fs-2 text-primary"></i>
                  </div>
                  <div className="flex-grow-1 overflow-hidden">
                    <p className="mt-4"><span className="text-secondary fw-bold fs-3">{metrics.totalUsers}</span> Utilisateurs</p>
                  </div>
                </div>
              </Link>
            </CardBody>
          </Card>
        </Col>

        {/* Total Creators */}
        <Col xl={3} sm={6}>
          <Card>
            <CardBody>
              <Link to="/adminManage" className="text-muted">
                <div className="d-flex text-muted">
                  <div className="flex-shrink-0 me-3 align-self-center">
                    <i className="mdi mdi-account-multiple-outline fs-2 text-primary"></i>
                  </div>
                  <div className="flex-grow-1 overflow-hidden">
                    <p className="mt-4"><span className="text-secondary fw-bold fs-3">{metrics.totalCreators}</span> Créateurs</p>
                  </div>
                </div>
              </Link>
            </CardBody>
          </Card>
        </Col>

        {/* Average Score */}
        <Col xl={3} sm={6}>
          <Card>
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <RadialChart1 metrics={metrics.averageScore.toFixed(0)} />
                </div>
                <div className="flex-grow-1 overflow-hidden ">
                  <p className="mt-4">Moyenne globale</p>
                  {/*<h5 className="mb-3">{metrics.averageScore.toFixed(2)}%</h5>
                  <p className="text-truncate mb-0 text-danger">
                    0.01% <i className="ri-arrow-right-down-line align-bottom ms-1"></i>
                  </p>*/}
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        {/* Total Chapters */}
        {/*  <Col xl={3} sm={6}>
          <Card>
            <CardBody>
              <div className="d-flex">
                <div className="flex-grow-1 overflow-hidden"
                title="Nombre de contenu déployés">
                  <p className="mb-1">
                    <i className="mdi mdi-book-multiple-outline text-primary me-2"></i>
                    <b>{metrics.totalChapters}</b> Référentiels
                  </p>
                  <p className="mb-1">
                    <i className="bx bx-wrench text-primary me-2"></i>
                    <b>12</b> Procédures
                  </p>
                  <p className="mb-1">
                    <i className="mdi mdi-school-outline text-primary me-2"></i>
                    <b>8</b> Formations
                  </p>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col> */}
      </Row>
    </React.Fragment>
  );
};

export default UserPanel;
